import React from 'react';
import { Box, Flex, Text, Stack } from '@tonic-ui/react';
import { useTranslation } from 'react-i18next';
import ctaSection from '../../../assets/images/cta-section.png';
import { CTAButtonRouteLink } from '../../../views/PublicLanding/hero-banner';

const BottomCTASection = () => {
  const { t } = useTranslation();
  return (
    <Stack alignItems="center" background={`url(${ctaSection}) center/cover`} minHeight="374px">
      <Flex marginTop="11x" justifyContent="center" position="relative" marginBottom="16x">
        <Box backgroundColor="white:secondary" width={{ sm: '300px', md: '394px' }} height="2px" />
        <Box
          textAlign="center"
          position="absolute"
          top="-8px"
          backgroundColor="red:70"
          width="188px"
          height="18px"
        >
          <Text fontFamily="interstate" size="xs" fontWeight={400} color="white">
            {t('publicLandingPage.bottomCTASection.workTogether')}
          </Text>
        </Box>
      </Flex>
      <Box marginBottom="6x" paddingRight="10%" paddingLeft="10%" textAlign={{ sm: 'center' }}>
        <Text
          fontFamily="interstate"
          fontSize={{ sm: '32px', md: '48px' }}
          lineHeight="58px"
          fontWeight={400}
          color="white:primary"
        >
          {t('publicLandingPage.bottomCTASection.getStarted')}
        </Text>
      </Box>
      <CTAButtonRouteLink />
    </Stack>
  );
};

BottomCTASection.displayName = 'BottomCTASection';

export default BottomCTASection;
